<app-main-app-layout>
    <router-outlet></router-outlet>
</app-main-app-layout>

<app-add-sub-account-modal></app-add-sub-account-modal>
<app-switch-account-modal></app-switch-account-modal>
<app-switch-vendor-modal></app-switch-vendor-modal>
<app-chat></app-chat>
<app-payment-confirmation-modal></app-payment-confirmation-modal>